import React, { useEffect, useState } from 'react';
import {
  useLexicalComposerContext,
} from '@lexical/react/LexicalComposerContext';

import { $createHeadingNode } from '@lexical/rich-text';
import { $createParagraphNode } from 'lexical';

import {
  $getSelection, $isRangeSelection, COMMAND_PRIORITY_HIGH,
  FORMAT_TEXT_COMMAND, SELECTION_CHANGE_COMMAND,
} from 'lexical';

import {
  $patchStyleText, $setBlocksType
} from '@lexical/selection';



const FONT_SIZES = ['12px', '14px', '16px', '18px', '24px', '36px'];
const FONT_FAMILIES = ['Arial', 'Georgia', 'Times New Roman', 'Courier New', 'Verdana'];

export const ToolbarPlugin = () => {
  const [editor] = useLexicalComposerContext();

  const applyFontSize = (size) => {
    editor.update(() => {
      const selection = $getSelection();
      if ($isRangeSelection(selection)) {
        $patchStyleText(selection, { 'font-size': size });
      }
    });
  };


  const applyTextAlign = (align) => {
  editor.update(() => {
    const selection = $getSelection();
    if ($isRangeSelection(selection)) {
      const nodes = selection.getNodes();

      for (const node of nodes) {
        const parent = node.getParent();
        const element = parent && parent.isElement() ? parent : node;

        if (element.isElement()) {
          element.setFormat(align); // <-- this is the key method
        }
      }
    }
  });
};



  const applyFontFamily = (family) => {
    editor.update(() => {
      const selection = $getSelection();
      if ($isRangeSelection(selection)) {
        $patchStyleText(selection, { 'font-family': family });
      }
    });
  };

  const applyTextColor = (color) => {
    editor.update(() => {
      const selection = $getSelection();
      if ($isRangeSelection(selection)) {
        $patchStyleText(selection, { color });
      }
    });
  };

  // const applyBlockType = (type) => {
  //   editor.update(() => {
  //     const selection = $getSelection();
  //     if ($isRangeSelection(selection)) {
  //       if (type === 'paragraph') {
  //         $setBlocksType(selection, () => $createParagraphNode());
  //       } else {
  //         $setBlocksType(selection, () => $createHeadingNode(type));
  //       }
  //     }
  //   });
  // };


const [selectionFormat, setSelectionFormat] = useState({ isBold: false, isItalic: false });

useEffect(() => {
  return editor.registerUpdateListener(({ editorState }) => {
    editorState.read(() => {
      const selection = $getSelection();
      if ($isRangeSelection(selection)) {
        setSelectionFormat({
          isBold: selection.hasFormat('bold'),
          isItalic: selection.hasFormat('italic'),
        });
      }
    });
  });
}, [editor]);




  return (
    <div className="toolbar">
      <button onClick={() => editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'bold')}>B</button>
      <button onClick={() => editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'italic')}>I</button>
      <button onClick={() => editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'underline')}>U</button>

      <select onChange={(e) => applyFontSize(e.target.value)} defaultValue="">
        <option value="" disabled>Font Size</option>
        {FONT_SIZES.map(size => (
          <option key={size} value={size}>{size}</option>
        ))}
      </select>

      <select onChange={(e) => applyFontFamily(e.target.value)} defaultValue="">
        <option value="" disabled>Font Family</option>
        {FONT_FAMILIES.map(font => (
          <option key={font} value={font}>{font}</option>
        ))}
      </select>

      <input
        type="color"
        onChange={(e) => applyTextColor(e.target.value)}
        title="Text Color"
        style={{ width: 40, height: 30 }}
      />

   



     {/* <select onChange={(e) => applyTextAlign(e.target.value)} defaultValue="">
  <option value="" disabled>Align</option>
  <option value="left">Left</option>
  <option value="center">Center</option>
  <option value="right">Right</option>
  <option value="justify">Justify</option>
</select> */}



    </div>
  );
};
